/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgot_Password_DescriptionInputs */

const en_auth_forgot_password_description = /** @type {(inputs: Auth_Forgot_Password_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request a password reset link to be sent to your email`)
};

const es_auth_forgot_password_description = /** @type {(inputs: Auth_Forgot_Password_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce tu email y te enviaremos instrucciones.`)
};

/**
* | output |
* | --- |
* | "Request a password reset link to be sent to your email" |
*
* @param {Auth_Forgot_Password_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_forgot_password_description = /** @type {((inputs?: Auth_Forgot_Password_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgot_Password_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_forgot_password_description(inputs)
	return es_auth_forgot_password_description(inputs)
});